import { atom } from "recoil";

export const allListUpdatedFlagState = atom<boolean>({
  key: "allListUpdatedFlagState",
  default: false,
});
